module.exports = "<p>cand-test-schedule works!</p>\n"